/**
 * Normalize phone for customer storage: digits only, no country code.
 * Example: "+1 876-123-4567" / "18761234567" → "8761234567"
 */
export class PhoneUtils {
  static toTenDigitPhone(phone: string | number | null | undefined): string {
    if (phone == null || phone === '') {
      return '';
    }
    let digits = String(phone).replace(/\D/g, '');
    // Strip NANP/Jamaica country code when present as 11 digits (1 + 10)
    if (digits.length === 11 && digits.charAt(0) === '1') {
      digits = digits.substring(1);
    }
    return digits;
  }
}



// WEBPACK FOOTER //
// ./src/app/utilities/PhoneUtils/PhoneUtils.ts